import GenericErrorBoundary from './Generic'

export * from './Generic'

export default GenericErrorBoundary
